import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const WEEK = 7 * 24 * 3600 * 1000;

export const VideoRequestBanner = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let t;
    const load = () => api.get("/generations", { params: { filter: "video_requests", limit: 5 } }).then(({ data }) => {
      setItems(data.items);
      if (data.items.some((g) => g.status === "PREPARING")) t = setTimeout(load, 20000);
    }).catch(() => {});
    load();
    return () => clearTimeout(t);
  }, []);
  const preparing = items.filter((g) => g.status === "PREPARING");
  const ready = items.filter((g) => g.status === "COMPLETED" && Date.now() - new Date(g.completed_at || g.created_at) < WEEK);
  if (!preparing.length && !ready.length) return null;
  return (
    <div className="mb-6 space-y-3" data-testid="video-request-banner">
      {ready.length > 0 && (
        <Link to="/panel/galeri" className="flex items-center justify-between rounded-2xl border border-emerald-500/40 bg-emerald-500/10 p-5 font-semibold text-emerald-500" data-testid="dashboard-video-ready">
          <span className="text-lg">🎉 Videonuz hazır!</span><span className="text-sm">İzle ve indir →</span>
        </Link>
      )}
      {preparing.length > 0 && (
        <div className="rounded-2xl border border-primary/30 bg-primary/5 p-5 font-semibold" data-testid="dashboard-video-preparing">🔄 Videonuz hazırlanıyor...</div>
      )}
    </div>
  );
};
